import React from 'react';


const RoleCode = (cell) => {
    return cell.value ? cell.value : '';
};

const RoleName = (cell) => {
    return cell.value ? cell.value : '';
};


export {
    RoleCode,
    RoleName,
    
};